import { render, staticRenderFns } from "./BlockInsert.vue?vue&type=template&id=04d716b4&scoped=true&"
import script from "./BlockInsert.vue?vue&type=script&lang=js&"
export * from "./BlockInsert.vue?vue&type=script&lang=js&"
import style0 from "./BlockInsert.vue?vue&type=style&index=0&id=04d716b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d716b4",
  null
  
)

export default component.exports